<template>
  <div>
    <el-container>
      <el-header style="font-weight: bold">{{ numberValidateForm.EventName }}</el-header>
      <el-main>
        <!-- 提示信息 -->
        <el-alert
          v-if="isEnd === 1"
          title="该活动已截止报名"
          type="error"
          :closable="false"
          center
          show-icon>
        </el-alert>
        <el-alert
          v-else-if="isEnd === 0"
          title="报名中"
          type="success"
          :closable="false"
          center
          show-icon>
        </el-alert>

        <p class="top_tex">
          <i class="el-icon-alarm-clock" style="font-size: 20px"></i>
          <span class="top_span">{{ numberValidateForm.Time }}</span>
        </p>
        <p class="top_tex">
          <i class="el-icon-location-outline" style="font-size: 20px"></i>
          <span class="top_span">{{ numberValidateForm.Address }}</span>
        </p>
        
        <el-form
          :model="numberValidateForm"
          ref="numberValidateForm"
          :rules="rules"
          class="demo-ruleForm"
          label-width="70px"
          :disabled="isEnd === 1">
          
          <el-form-item prop="Name" label="姓名">
            <el-input
              v-model="numberValidateForm.Name"
              autocomplete="off"
              placeholder="姓名"
            ></el-input>
          </el-form-item>
          <el-form-item prop="Company" label="公司">
            <el-input
              v-model="numberValidateForm.Company"
              autocomplete="off"
              placeholder="公司"
            ></el-input>
          </el-form-item>
          <el-form-item prop="Post" label="职务">
            <el-input
              v-model="numberValidateForm.Post"
              autocomplete="off"
              placeholder="职务"
            ></el-input>
          </el-form-item>
          <el-form-item prop="Phone" label="手机号">
            <el-input
              v-model="numberValidateForm.Phone"
              autocomplete="off"
              placeholder="手机号"
            ></el-input>
          </el-form-item>
          
          <!-- 是否用餐 -->
          <!-- <el-form-item label="是否用餐"  v-if="isEat === '1'">
            <div>
              <el-radio v-model="numberValidateForm.Resource" label="1" border
                >是</el-radio>
              <el-radio v-model="numberValidateForm.Resource" label="0" border
                >否</el-radio>
            </div>
          </el-form-item> -->
          
          <!-- 用餐详情 -->
          <el-form-item label="用餐" v-if=" Object.keys(mealDetail).length > 0">
            <div class="meal-item" v-for="(meal, key) in mealDetail" :key="key">
              <el-checkbox
                v-model="selectedMeals[key]"
                :label="meal"
              >{{ meal }}</el-checkbox>
            </div>
          </el-form-item>
          
          <!-- 考察详情 -->
          <el-form-item label="考察" v-if="Object.keys(investigateDetail).length > 0">
            <div class="investigate-item" v-for="(investigate, key) in investigateDetail" :key="'investigate-' + key">
              <el-checkbox
                v-model="selectedInvestigates[key]"
                :label="investigate"
              >{{ investigate }}</el-checkbox>
            </div>
          </el-form-item>
          
          <el-form-item prop="Remarks" label="备注">
            <el-input
              v-model="numberValidateForm.Remarks"
              autocomplete="off"
              :placeholder="remarks"
            ></el-input>
          </el-form-item>
          
          <div class="box_bottom">
            <el-button
              type="primary"
              @click="submitForm('numberValidateForm')"
              class="submit"
              :disabled="isEnd === 1"
              >提交</el-button
            >
          </div>
          <div class="box_bottom">
            <div>
              <img
                src="../../src/assets/lQLPJxh0zzdyHmDNAprNC9uwX01sHGdsUxUE0zysSgBVAA_3035_666.png"
                alt=""
                class="logo"
              />
            </div>
            <div>Copyright © 2024 E20环境平台 京10040015号-7</div>
          </div>
        </el-form>

        <el-dialog
          title="报名成功————当前报名信息"
          :visible.sync="dialogVisible"
          width="100vw"
          :before-close="handleCloseDialog">
          <p>活动名称：{{ data.activity_name }}</p>
          <p>活动地址：{{ data.address }}</p>
          <p>公司：{{ data.company }}</p>
          <p>手机号：{{ data.mobile }}</p>
          <p>职务：{{ data.position }}</p>
          <p>姓名：{{ data.name }}</p>
          <p v-if="data.remarks">备注：{{ data.remarks }}</p>
          <p v-if="data.meal_detail && Object.keys(data.meal_detail).length > 0">用餐详情：{{ formatMeals }}</p>
          <p v-if="data.investigate_detail && Object.keys(data.investigate_detail).length > 0">考察详情：{{ formatInvestigates }}</p>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handleCloseDialog">取 消</el-button>
            <el-button type="primary" @click="handleCloseDialog"
              >确 定</el-button
            >
          </span>
        </el-dialog>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import { getSalonInfo, submitApplication, getApplicationDetail } from "../http/axios";

export default {
  data() {
    return {
      xiangqingId: '',
      dialogVisible: false,
      id: "",
      isEat: "",
      remarks: "",
      isEnd: null,
      numberValidateForm: {
        id: "",
        EventName: "",
        Time: "",
        Address: "",
        Name: "",
        Company: "",
        Post: "",
        Phone: "",
        // Resource: ,
        Remarks: "",
      },
      data: {
        activity_name: "",
        address: "",
        company: "",
        mobile: "",
        name: "",
        position: "",
        remarks: "",
        meal_detail: {}, // 用于存储用餐详情
        investigate_detail: {} // 用于存储考察详情
      },
      rules: {
        Name: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
        Company: [{ required: true, message: "公司不能为空", trigger: "blur" }],
        Post: [{ required: true, message: "职务不能为空", trigger: "blur" }],
        Phone: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "请输入正确的手机号格式",
            trigger: "blur",
          },
        ],
      },
      mealDetail: {},
      investigateDetail: {},
      selectedMeals: {},
      selectedInvestigates: {},
    };
  },
  computed: {
    formatMeals() {
      return Object.keys(this.data.meal_detail).filter(key => this.data.meal_detail[key]).map(key => this.data.meal_detail[key]).join('、') || '无';
    },
    formatInvestigates() {
      return Object.keys(this.data.investigate_detail).filter(key => this.data.investigate_detail[key]).map(key => this.data.investigate_detail[key]).join('、') || '无';
    }
  },
  methods: {
    fetchData() {
      this.id = this.$route.query.id;
      getSalonInfo({ id: this.id })
        .then((res) => {
          console.log(res, '沙龙信息');
          if (res.error !== 0) {
            this.$router.push({ path: "/404" });
            return;
          }
          const { data } = res;
          this.numberValidateForm.id = data.id;
          this.isEat = data.is_meal;
          this.numberValidateForm.EventName = data.name;
          // this.numberValidateForm.Resource = data.is_meal;
          this.numberValidateForm.Time = data.time_show;
          this.numberValidateForm.Address = data.address;
          this.remarks = data.remarks;
          this.isEnd = data.is_end;
          
          this.mealDetail = data.meal_detail || {};
          
          this.investigateDetail = data.investigate_detail || {};
        })
        .catch((error) => {
          console.error("获取沙龙活动配置信息失败:", error);
          this.$message.error('获取数据失败，请稍后重试');
        });
    },
submitForm(formName) {
  this.$refs[formName].validate((valid) => {
    if (valid && this.isEnd === 0) {
      const mealDetails = {};
      Object.keys(this.selectedMeals).forEach(key => {
        if (this.selectedMeals[key]) {
          mealDetails[key] = this.mealDetail[key];
        }
      });
      
      const investigateDetails = {};
      Object.keys(this.selectedInvestigates).forEach(key => {
        if (this.selectedInvestigates[key]) {
          investigateDetails[key] = this.investigateDetail[key];
        }
      });

      // 检查是否选择了用餐选项
      const hasMeals = Object.keys(mealDetails).length > 0;
      // 检查是否选择了考察选项
      const hasInvestigates = Object.keys(investigateDetails).length > 0;

      submitApplication({
        activity_id: this.numberValidateForm.id,
        name: this.numberValidateForm.Name,
        company: this.numberValidateForm.Company,
        position: this.numberValidateForm.Post,
        mobile: this.numberValidateForm.Phone,
        // is_havemeals: hasMeals ? this.numberValidateForm.Resource : null,
        meal_detail: hasMeals ? JSON.stringify(mealDetails) : null,
        investigate_detail: hasInvestigates ? JSON.stringify(investigateDetails) : null,
        remarks: this.numberValidateForm.Remarks,
      })
      .then((res) => {
        if (res.error === 0) {
          this.xiangqingId = res.data.id;
          // 获取报名详情
          getApplicationDetail({ id: this.xiangqingId })
            .then((detailRes) => {
              if (detailRes.error === 0) {
                this.data = {
                  activity_name: detailRes.data.activity_name,
                  address: detailRes.data.address,
                  company: detailRes.data.company,
                  mobile: detailRes.data.mobile,
                  name: detailRes.data.name,
                  position: detailRes.data.position,
                  remarks: detailRes.data.remarks || '',
                  meal_detail: detailRes.data.meal_detail || {},
                  investigate_detail: detailRes.data.investigate_detail || {}
                };
                this.dialogVisible = true;
              } else {
                this.$message.error('获取报名详情失败');
              }
            })
            .catch((error) => {
              console.error('获取报名详情失败:', error);
              this.$message.error('获取报名详情失败，请稍后重试');
            });
          
          // 重置表单和多选框状态
          this.$refs[formName].resetFields();
          Object.keys(this.selectedMeals).forEach(key => {
            this.$set(this.selectedMeals, key, false);
          });
          Object.keys(this.selectedInvestigates).forEach(key => {
            this.$set(this.selectedInvestigates, key, false);
          });
        } else {
          this.$message({
            message: res.msg,
            type: "warning",
          });
        }
      })
      .catch(error => {
        this.$message.error('提交失败，请稍后重试');
        console.error('报名提交失败:', error);
      });
    }
  });
},
    handleCloseDialog() {
      this.dialogVisible = false;
      this.$refs.numberValidateForm.resetFields();
      // 使用 $set 确保响应式更新
      Object.keys(this.selectedMeals).forEach(key => {
        this.$set(this.selectedMeals, key, false);
      });
      Object.keys(this.selectedInvestigates).forEach(key => {
        this.$set(this.selectedInvestigates, key, false);
      });
    }
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style scoped>
.top_tex {
  font-size: 14px;
  padding: 10px 0px;
  display: flex;
}
.top_span {
  display: inline-block;
  margin-left: 13px;
}
.addbtn {
  width: 100%;
}
.submit {
  width: 100%;
}
.el-header,
.el-footer {
  background-color: rgb(115, 154, 123);
  color: white;
  text-align: center;
  height: auto !important;
  padding: 10px;
}

.el-aside {
  background-color: #d3dce6;
  color: #333;
  text-align: center;
  line-height: 200px;
}

.el-main {
  background-color: white;
  color: #333;
  line-height: 15px;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}

.box_bottom > div {
  line-height: 30px !important;
  font-size: 2.2vw;
  text-align: center;
}

.box_bottom {
  margin-top: 20px !important;
}

.box_bottom > div {
  margin-top: 10px;
}

.logo {
  width: 50%;
  margin: auto;
}

.meal-item {
  margin-bottom: 10px;
  text-align: left;
}
.el-form-item >>> .el-form-item__content {
  display: flex;
  flex-direction: column;
}
/* 限制内容宽度，添加换行 */
.el-checkbox {
  display: flex;
  white-space: normal;
  word-break: break-all;
  padding: 5px;
}

.investigate-item {
  margin-bottom: 10px;
  text-align: left;
}


@media (min-width: 768px) {
  .top_tex {
    width: 50%;
    margin: auto;
    display: flex;
  }
  .el-form-item {
    width: 50%;
    margin: auto;
    padding: 10px;
  }

  .logo {
    width: 30%;
  }

  .box_bottom {
    width: 50%;
    margin: auto;
  }

  .box_bottom > div {
    line-height: 30px !important;
    font-size: 1.5vw;
    text-align: center;
  }
}

@media (max-width: 767px) {
  .el-form-item {
    width: 100%;
  }
  .meal-item, .investigate-item {
    width: 100%;
  }
  .box_bottom {
    width: 100%;
  }
}
</style>